import React, { useCallback } from 'react';

import { DOCUMENT_V1_SORTING, DOCUMENT_TYPES } from '@lumapps/medias-document/constants';
import type { DocumentV1 } from '@lumapps/medias-document/types';
import { isDocumentPdfFile } from '@lumapps/medias-document/utils/isDocumentPdfFile';
import { useTranslate } from '@lumapps/translations';

import { PDF_PICKER_SORTING_FIELDS } from '../../constants';
import { FILE_PICKER } from '../../keys';
import { FilePickerDialog, type FilePickerDialogProps } from '../FilePickerDialog';

export type PdfPickerDialogProps = FilePickerDialogProps;

/**
 * Renders a picker dialog for selecting a single PDF file from the site's media library.
 *
 * @returns PdfPickerDialog
 */
export const PdfPickerDialog: React.FC<PdfPickerDialogProps> = (props) => {
    const { translateKey } = useTranslate();

    const itemSelectableSelector = useCallback((item: DocumentV1) => isDocumentPdfFile(item), []);

    return (
        <FilePickerDialog
            initialSort={DOCUMENT_V1_SORTING.CREATED_DESC}
            itemSelectableSelector={itemSelectableSelector}
            searchTypes={[DOCUMENT_TYPES.FOLDER, DOCUMENT_TYPES.OTHER]}
            sorts={PDF_PICKER_SORTING_FIELDS}
            title={translateKey(FILE_PICKER.SELECT_PDF)}
            {...props}
        />
    );
};
